import React, { useEffect } from 'react';
import { Wrapper } from './styles';
const MobilePanelContainer = ({ mobilePanelDisplay, children }) => {
    useEffect(() => {
        if (typeof document !== 'undefined' && mobilePanelDisplay === true) {
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100vh';
        }
        else {
            document.body.style.overflow = '';
            document.body.style.height = '';
        }
    }, [mobilePanelDisplay]);
    return (React.createElement(React.Fragment, null, mobilePanelDisplay ? React.createElement(Wrapper, { "$open": mobilePanelDisplay }, children) : null));
};
export default MobilePanelContainer;
//# sourceMappingURL=index.js.map